import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { UpdatePapsNumberDto } from 'dtos'
import { Formik } from 'formik'
import { enqueueSnackbar } from 'notistack'
import * as yup from 'yup'
import LabelField from './LabelField'

const updatePapsNumberValidationSchema = yup.object({
  papsNumber: yup.string().min(200, 'PAPS# cannot be more than 200 characters.').required('PAPS# is required.')
})

interface UpdatePapsNumberDialogProps {
  isLoading?: boolean
  open: boolean
  initialValues: UpdatePapsNumberDto
  onClose: () => void
  onSave: (values: UpdatePapsNumberDto) => void
}

export default function UpdatePapsNumberDialog({
  isLoading,
  onClose,
  open,
  onSave,
  initialValues
}: UpdatePapsNumberDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnBlur
        validateOnChange
        validationSchema={updatePapsNumberValidationSchema}
        onSubmit={values => {
          enqueueSnackbar('PAPS# Updated Successfully!', { variant: 'success' })
          onClose()
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Update PAPS#</DialogTitle>

                  <Grid item xs={12}>
                    {/* <LabelField
                      label='VIN(s)'
                      value={values.vehicles.map(vehicle => vehicle.vin!)}
                    /> */}
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      error={Boolean(touched.papsNumber && errors.papsNumber)}
                      fullWidth
                      helperText={touched.papsNumber && errors.papsNumber}
                      label='PAPS#'
                      name='papsNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.papsNumber || ''}
                    />
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions sx={{ mb: 2, mr: 2 }}>
                <Button color='secondary' disabled={isLoading} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading} type='submit' variant='contained'>
                  ASSIGN/UNASSIGN
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
